// extracted by mini-css-extract-plugin
module.exports = {"hidingHeader":"SocialLinks_hidingHeader__GBow4","hidingHeader-in":"SocialLinks_hidingHeader-in__7upp0","wrapper":"SocialLinks_wrapper__5ZMsx","text":"SocialLinks_text__OU7Ot"};